import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const ContactContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  row-gap: 24px;
  box-shadow: -1px 3px 16px rgba(149, 157, 165, 0.19);
  padding: 24px;
  margin-top: 16px;
`;

export const ContactRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  flex: 1;
  max-width: 500px;

  > div {
    width: 50%;
  }

  ${mediaQuery(BREAKPOINTS.medium)} {
    margin-left: 0;
    flex: auto;
  }

  ${mediaQuery(BREAKPOINTS.small)} {
    > div {
      width: 100%;
    }

    > div:empty {
      display: none;
    }
  }
`;

export const TitleContainer = styled.div`
  margin-top: 24px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${mediaQuery(BREAKPOINTS.desktop, 'min')} {
    flex-direction: row;
  }
`;

export const ColumnWrapper = styled.div`
  ${mediaQuery('desktop', 'min')} {
    &:first-of-type {
      width: calc(60% - 50px);
      margin-right: 50px;
    }
    &:last-of-type {
      width: 40%;
    }
  }
`;

export const ItemContainer = styled.div`
  background-color: ${(props) => props.theme.color.light.default};
  margin-bottom: 30px;
  box-shadow: -1px 3px 16px rgba(149, 157, 165, 0.19);
`;

export const ItemWrapper = styled.div<{ withBorder?: boolean }>`
  padding: 24px;
  ${(props) => props.withBorder && `border-top: 1px solid ${props.theme.color.light.shadeLighter}`};
`;

export const EmptyWrapper = styled.div`
  text-align: center;
`;

export const ItemWrapperRow = styled.div<{
  marginTop?: number;
  alignCenter?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  row-gap: 16px;
  ${(props) => props.alignCenter && 'align-items: center'};
  ${(props) => props.marginTop && `margin-top: ${props.marginTop}px`};

  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const ItemWrapperCol = styled.div<{ width?: number }>`
  ${mediaQuery('small', 'min')} {
    width: ${(props) => (props.width ? `${props.width}%` : '50%')};
  }
`;

export const ItemWrapperLabel = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.color.medium.default};
`;

export const ItemWrapperValue = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.color.dark.shade};
  margin-top: 8px;
`;

export const ItemImg = styled.img`
  object-fit: cover;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin-right: 8px;
`;

export const DetailGroupWrapper = styled.div`
  background: ${(props) => props.theme.color.light.tintDarker};
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 8px;
`;

export const DetailGroupLabel = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 700;
  font-size: 16px;
`;

export const DetailWrapper = styled.div`
  margin-top: 20px;
`;

export const DetailLabel = styled.div`
  color: ${(props) => props.theme.color.medium.default};
  font-weight: 600;
  font-size: 15px;
`;

export const DetailValue = styled.div`
  color: ${(props) => props.theme.color.dark.shade};
  margin-top: 8px;
  font-size: 14px;
`;
export const RejectButton = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${(props) => props.theme.color.red.default};
  font-family: ${(props) => props.theme.font.default} !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 5px;
  }
  width: 100%;
  justify-content: right;
  white-space: pre;
`;
